import React, { Component } from 'react';

import { Header, Navbar } from '@C';
import { Reminder } from '@C/CreditCustomerProfile/Reminders';
import ErrorBoundary from '@C/Error';

class RemindersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Create dealer" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <ErrorBoundary>
                <Reminder />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { RemindersPage };
